<template>
    <div class="regulation-section">
        <div class="container">
            <div class="content-wrapper">
                <!-- Left Side - Image -->
                <div class="image-container">
                    <div class="image-wrapper">
                        <img src="/wp-content/uploads/2024/02/comoross-1024x1024.png" alt="Comoros Regulation"
                            class="main-image">
                    </div>
                </div>

                <!-- Right Side - Content -->
                <div class="text-container">
                    <h1 class="main-title">Financial Service Provider</h1>

                    <div class="content-text">
                        <p>
                            Restricts its services to residents of certain countries due to differing local laws and
                            regulations.
                            These are Afghanistan, Belarus, Belgium, Botswana, Brazil, Burundi, Colombia, Congo, Cuba,
                            Egypt, Guinea,
                            Guinea-Bissau, Iran, Iraq, Israel, Japan, Lebanon, Liberia, Libyan Arab Jamahiriya, Mali,
                            Myanmar,
                            New Zealand, Nicaragua, Nigeria, North Korea, Pakistan, Somalia, Somali Republic, South
                            Africa, Spain,
                            Sudan, Syria, Togo, Ukraine, United States of America (including its territories),
                            Venezuela, Yemen, and Zimbabwe.
                        </p>

                        <p>
                            Additionally, the information on the company's website is not targeted towards residents of
                            U.S., Israel,
                            New Zealand, Iran, and North Korea, officially known as the Democratic People's Republic of
                            Korea, or use
                            by any person in any country where it would be illegal.
                        </p>
                    </div>

                    <div class="license-section">
                        <h2 class="section-title">License</h2>
                        <p>
                            Socrates Legacy is operated by Socrates Legacy LTD and has registered by
                            <strong>Comoros Union</strong> with <strong>International Brokerage and Clearing Houses
                                license</strong>.
                            License Number : <strong>L 34695 /SL</strong>
                        </p>

                        <a href="#" class="certificate-button">
                            Show Certificate
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RegulationSection'
}
</script>

<style scoped>
.regulation-section {
    background: #f5f5f5;
    padding: 100px 0;
    position: relative;
    overflow: hidden;
}

.container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    position: relative;
    z-index: 1;
}

.content-wrapper {
    display: flex;
    align-items: center;
    /* gap: 60px; */
    /* background: #fff; */
    /* border-radius: 20px; */
    /* padding: 60px; */
    /* box-shadow: 0 10px 50px rgba(0, 0, 0, 0.05); */
}

/* Left Side - Image */
.image-container {
    flex: 0 0 50%;
    position: relative;
}

.image-wrapper {
    position: relative;
    /* border-radius: 16px; */
    overflow: hidden;
    /* background: linear-gradient(135deg, #f8f8f8 0%, #e8e8e8 100%); */
    /* padding: 30px; */
    display: flex;
    align-items: center;
    justify-content: center;
}

.main-image {
    width: 100%;
    height: auto;
    max-width: 400px;
    object-fit: contain;
    display: block;
}

/* Right Side - Content */
.text-container {
    flex: 1;
}

.main-title {
    color: #1a1a1a;
    font-size: 1.5rem;
    font-weight: 700;
    font-family: "Fira Sans", Sans-serif;
    margin-bottom: 18px;
    line-height: 0.75;
}

.content-text {
    margin-bottom: 10px;
}

.content-text p {
    color: #666;
    font-size: 0.9rem;
    line-height: 1.6;
    margin-bottom: 15px;
}

.content-text p:last-child {
    margin-bottom: 0;
}

/* License Section */
.license-section {
    /* border-top: 2px solid #f0f0f0; */
    padding-top: 0px;

}

.section-title {
    color: #1a1a1a;
    font-size: 1.5rem;
    font-weight: 700;
    margin-bottom: 5px;
    font-family: "Fira Sans", Sans-serif;

}

.license-section p {
    color: #666;
    font-size: 0.9rem;
    line-height: 1.6;
    margin-bottom: 15px;
}

.license-section strong {
    color: #1a1a1a;
    font-weight: 700;
}

.certificate-button {
    display: inline-block;
    background: linear-gradient(135deg, #D4AF37 0%, #aa8811 100%);
    color: #fff;
    padding: 10px 32px;
    border-radius: 3px;
    font-size: 1rem;
    font-weight: 700;
    text-decoration: none;
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba(212, 175, 55, 0.3);
}

.certificate-button:hover {
    background: linear-gradient(135deg, #e0c35c 0%, #c09620 100%);
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(212, 175, 55, 0.4);
}

/* Responsive Design */
@media (max-width: 992px) {
    .content-wrapper {
        gap: 40px;
        padding: 50px 40px;
    }

    .main-title {
        font-size: 2rem;
    }

    .section-title {
        font-size: 1.5rem;
    }

    .image-container {
        flex: 0 0 40%;
    }
}

@media (max-width: 768px) {
    .regulation-section {
        padding: 60px 0;
    }

    .content-wrapper {
        flex-direction: column;
        gap: 40px;
        padding: 40px 30px;
    }

    .image-container {
        flex: 0 0 100%;
        max-width: 400px;
        margin: 0 auto;
    }

    .text-container {
        text-align: left;
    }

    .main-title {
        font-size: 1.75rem;
    }

    .content-text p {
        font-size: 0.95rem;
    }

    .section-title {
        font-size: 1.4rem;
    }

    .license-section p {
        font-size: 0.95rem;
    }
}

@media (max-width: 480px) {
    .regulation-section {
        padding: 40px 0;
    }

    .content-wrapper {
        padding: 30px 20px;
        gap: 30px;
    }

    .image-wrapper {
        padding: 20px;
    }

    .main-image {
        max-width: 100%;
    }

    .main-title {
        font-size: 1.5rem;
        margin-bottom: 20px;
    }

    .content-text {
        margin-bottom: 30px;
    }

    .content-text p {
        font-size: 0.9rem;
        line-height: 1.7;
    }

    .license-section {
        padding-top: 25px;
    }

    .section-title {
        font-size: 1.3rem;
        margin-bottom: 12px;
    }

    .license-section p {
        font-size: 0.9rem;
        margin-bottom: 20px;
    }

    .certificate-button {
        width: 100%;
        text-align: center;
        padding: 12px 24px;
        font-size: 0.95rem;
    }
}
</style>
